/** Must match TimesheetAiReportDrawer DRAWER_TRANSITION_MS (body scroll-lock duration). */
export const AI_DRAWER_TRANSITION_MS = 320;

/** Fraction of element height that must be visible to skip auto-scroll on row select. */
export const DETAIL_PANEL_VISIBLE_RATIO = 0.35;

/**
 * Wait until after the AI drawer unmounts and body scroll-lock restores savedScrollY.
 */
export const AI_DRAWER_SCROLL_DELAY_MS = AI_DRAWER_TRANSITION_MS + 120;

/**
 * True when enough of the element is inside the viewport (no page scroll needed).
 */
export const isElementMostlyVisible = (
  element,
  ratio = DETAIL_PANEL_VISIBLE_RATIO
) => {
  if (!element || typeof element.getBoundingClientRect !== "function") {
    return false;
  }

  const rect = element.getBoundingClientRect();
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight || 0;

  if (viewportHeight <= 0 || rect.height <= 0) return false;

  const visibleTop = Math.max(rect.top, 0);
  const visibleBottom = Math.min(rect.bottom, viewportHeight);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);

  return visibleHeight / rect.height >= ratio;
};

/**
 * Scroll the detail panel into view only when it is mostly off-screen.
 * @returns {boolean} whether a scroll was performed
 */
export const scrollDetailPanelIntoViewIfNeeded = (
  element,
  { behavior = "smooth", block = "nearest" } = {}
) => {
  if (!element) return false;
  if (isElementMostlyVisible(element)) return false;

  element.scrollIntoView({ behavior, block });
  return true;
};

/**
 * Always scroll the detail panel into view after AI "Go to tab" navigation.
 * Runs after drawer scroll-lock releases so the scroll is not undone.
 */
export const scrollDetailPanelForAiNavigation = (element) => {
  if (!element) return;

  const scroll = () => {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  scroll();
  requestAnimationFrame(() => {
    requestAnimationFrame(scroll);
  });
};
